import { useQuery } from '@tanstack/react-query'

import { type CampaignHealth, campaignHealthFromServer } from 'models/campaign-health-model'
import { get } from 'utils/http'

// Campaign health (plain typed object now the model is de-Immutabled).
export const useCampaignHealth = (id: any) =>
  useQuery({
    queryKey: ['campaignHealth', id],
    queryFn: async (): Promise<CampaignHealth> =>
      campaignHealthFromServer(await get(`/management/campaigns/${id}/health`)),
    enabled: !!id,
  })
